import script from "./ScheduleEventBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduleEventBox.vue?vue&type=script&setup=true&lang=ts"

import "./ScheduleEventBox.vue?vue&type=style&index=0&id=03f174d8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f174d8"]])

export default __exports__